<app-sharepoint-table #externalCostGrid [configuration]="this.tableConfig">
</app-sharepoint-table>
